import "./App.css";
import Header from "./components/Header";
import Contact from "./components/Contact";
import {
  Hero,
  About,
  Services,
  Expertise,
  FeaturedQuote,
  Testimonials,
  TrunkDivider,
} from "./components/Sections";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <TrunkDivider />
        <About />
        <Services />
        <Expertise />
        <FeaturedQuote />
        <Testimonials />
        <Contact />
      </main>
    </div>
  );
}

export default App;
